export default {
	name: 'task_0',
	description: 'Заставка',
	title: 'Игра «Криминология и профилактика преступности»',
	minigameType: 'Greeting',
	mode: 0,
	messages() {
		return {
			onStart: "Приветствуем Вас в демо-версии игры «Криминология и профилактика преступности», предназначенной для свободного доступа. Здесь вы сможете ознакомиться с основным функционалом игры.",
		};
	},
	generateParams() {
		return {};
	},
	isCompleted: () => true,
	score: 0,
	maxScore: 0,
};